interface IContactConfig {
  equitesWhatsAppNumber: string;
}

export const ContactConfig: IContactConfig = {
  equitesWhatsAppNumber: import.meta.env.VITE_EQUITES_WPP_NUMBER ?? '',
};
